/**
 * Centralized Badge System
 * All badge components and logic exported from one place
 */

// Canonical rendering components (single source of truth)
export { Badge, type BadgeSize } from './badge'
export {
  BadgeList,
  type BadgeListVariant,
  type BadgePlacement,
} from './badge-list'

// Selection helpers (ordering, dedup, seen_before overlay, type→Badge)
export {
  sortBadges,
  applyMax,
  withSeenBefore,
  badgesFromTypes,
} from './select'

// Loose-product → canonical Badge[] adapters (sidebar / sitewide widgets that
// only have raw fields, no server-computed `badges` array yet).
export {
  badgesForSignals,
  badgesFromRecommended,
  type ProductBadgeSignals,
} from './from-product'

// Compatibility wrappers (delegate to BadgeList; accept legacy `product`)
export { ProductHeroBadges } from './product-hero-badges'
export { ProductCardBadges } from './product-card-badges'
export { CollectionBadge } from './collection-badges'

// Retailer Offer Badges (offer-level, intentionally separate — spec §4.4)
export {
  DealBadge,
  SavingsPercentageBadge,
  DealCountdown,
  LowStockWarning,
  BuyBoxWinnerBadge,
  PricePerUnit,
} from './offer-badges'

// Config & Logic
export {
  BADGE_CONFIGS,
  determineBadges,
  getBadgeConfig,
  makeBadge,
  type BadgeType,
  type BadgeConfig,
  type Badge as BadgeData,
} from './config'
